import React, { useState } from 'react';
import { collection, addDoc, Timestamp } from 'firebase/firestore';
import { db } from '../firebase'; // Import your Firebase db instance
import NavbarAdmin from '../components/NavbarAdmin';

const AddEtatFinan = () => {
  const [etat, setEtat] = useState({
    annee: '',
    lien: ''
  });

  // Calculate the range of years
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let i = currentYear - 5; i <= currentYear + 5; i++) {
    years.push(i);
  }

  // Handle changes in form inputs
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEtat({ ...etat, [name]: value });
  };

  // Function to convert Google Drive view link to preview link
  const convertToPreviewLink = (link) => {
    if (link.includes('drive.google.com')) {
      return link.replace('/view', '/preview');
    }
    return link; // Return the link unchanged if it's not a Google Drive link
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    const previewLink = convertToPreviewLink(etat.lien); // Convert the link before saving
    try {
      await addDoc(collection(db, 'etat_finance'), {
        ...etat,
        lien: previewLink, // Save the converted link
        timestamp: Timestamp.now()
      });
      console.log("Document successfully written!");
      // Clear the form after successful submission
      setEtat({
        annee: '',
        lien: ''
      });
    } catch (error) {
      console.error("Error adding document: ", error);
    }
  };

  const containerStyle = {
    padding: '20px',
    maxWidth: '800px',
    margin: '0 auto',
    fontFamily: 'Arial, sans-serif',
  };

  const headingStyle = {
    fontSize: '2rem',
    color: '#6699CC',
    fontFamily: 'Chalkboard, Comic Sans MS, cursive, sans-serif',
    margin: '20px 0',
    textAlign: 'center',
    borderBottom: '2px solid #ddd',
    paddingBottom: '10px',
  };

  const formStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    margin: '0 auto',
    maxWidth: '600px',
  };

  const inputStyle = {
    padding: '10px',
    borderRadius: '4px',
    border: '1px solid #ddd',
    width: '100%',
    boxSizing: 'border-box',
  };

  const buttonStyle = {
    padding: '10px 20px',
    backgroundColor: '#6699CC',
    border: 'none',
    borderRadius: '4px',
    color: '#fff',
    fontSize: '1rem',
    cursor: 'pointer',
  };

  return (
    <div>
      <NavbarAdmin />
      <div style={containerStyle}>
        <h2 style={headingStyle}>Ajouter les états financiers</h2>
        <form onSubmit={handleSubmit} style={formStyle}>
          <label>
            Année :
            <select
              name="annee"
              value={etat.annee}
              onChange={handleInputChange}
              required
              style={inputStyle}
            >
              <option value="">Sélectionnez l'année</option>
              {years.map(year => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
          </label>
          <label>
            Lien Drive :
            <input
              type="text"
              name="lien"
              value={etat.lien}
              onChange={handleInputChange}
              required
              style={inputStyle}
            />
          </label>
          <button type="submit" style={buttonStyle}>Ajouter</button>
        </form>
      </div>
    </div>
  );
};

export default AddEtatFinan;
